import { useEffect, useState } from "react";
import { TableActions } from "../../components/others/TableActions/index";
import LavorisService from "../../services/LavorisService";
import AddContacts from "../others/addContacts";
import UpdateContact from "../others/updateContacts";
import { useModal } from "../../hooks";
import { PhoneNumber } from "../../utils/phoneNumber";
import InfiniteTable from "../../components/others/InfiniteTableComponent/IntiniteTableComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../store/combineReducer";
import { useAlert } from "../../hooks/useAlert";
import DeleteIcon from '@mui/icons-material/Delete';



const Contactos = () => {
  const { openModal, closeModal, isActive } = useModal();
  const { showAlert } = useAlert();
  const LavorisInstance = LavorisService.getInstance();
  const { currentCompany, companies } = useSelector((state: RootState) => state.user,);
  const companyId = currentCompany ? currentCompany.id : companies[0].id;
  const [contactstData, setContactData] = useState<any[]>();
  const onClose = (urlElement: string) => { closeModal(urlElement) };


  const getContactsCall = async () => {
    try {
      const contacts: any = await LavorisInstance.CompanyServices.findCompanyContacts(companyId);
      setContactData(contacts);
    } catch (e) {
      console.log(e);
    }
  };


  useEffect(() => {
    getContactsCall();
  }, []);



  const onDelete = async (id: string, name: string) => {
    const content = {
      title: `¿Está seguro que desea eliminar al contacto ${name}?`,
      subtitle: (
        <div className="flex flex-col">
          <span>Al aceptar, esta será eliminada</span>
          <span>y la acción no podra volver para atrás</span>
        </div>
      ),
      icon: <DeleteIcon sx={{ fontSize: 44, color: '#DD6E6B' }} />,
    };

    const action = {
      onAccept: async () => {
        try {
          await LavorisInstance.CompanyServices.deleteContact(id);
          await getContactsCall();
        } catch (error) {
          console.log(error)
          alert('No se pudo eliminar el contacto')
        }
      }
    }

    showAlert(content, action,);
  }

  return (
    <>
      <div className="custom-header mt-4 pt-2">
        <div className="header-controls">
          {/* Search Section */}
          <div className="search-section">
          </div>

          {/* Actions Section */}
          <div className="actions-section">
            <button
              type="button"
              className="add-btn"
              onClick={() => {
                openModal("modalContacts");
              }}
              title="Agregar"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M8 3.333v9.334M3.333 8h9.334"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="btn-text">Agregar contacto</span>
            </button>
          </div>
        </div>
      </div>

      <InfiniteTable
        data={contactstData || []}
        columns={[
          {
            key: 'fullname',
            title: 'Apellido, Nombre',
            className: 'col-name',
            expandable: false,
            render: (value: string) => value?.toUpperCase() || "No disponible"
          },
          {
            key: 'phone_number',
            title: 'Teléfono',
            className: 'col-phone',
            render: (value: string) => PhoneNumber(value) || "No disponible"
          },
          {
            key: 'position',
            title: 'Puesto',
            className: 'col-position',
            render: (value: any) => {
              return value?.name || "No disponible"
            }
          },
          {
            key: 'email',
            title: 'Email',
            className: 'col-email',
            expandable: true,
            render: (value: string) => value || "No disponible"
          },
          {
            key: 'billing_email_enable',
            title: 'Habilitado para recibir emails',
            className: 'col-billing-email-enabled',
            render: (value: boolean) => value ? "Si" : "No"
          },
          {
            key: 'actions',
            title: 'Acciones',
            className: 'col-actions',
            render: (value: any, rowData: any) => {              
              const button = (
                <div className="flex gap-2 justify-center">
                  <TableActions
                    type="Edit"
                    onClick={() => {
                      openModal("modalUpdateContact", rowData.id);
                    }}
                  />
                  <TableActions
                    type="Delete"
                    onClick={() => onDelete(rowData.id, rowData.fullname)}
                  />
                </div>
              );
              return button;
            }
          }
        ]}
        hasMore={true}
        onLoadMore={() => { }}
        loading={false}
        height={570}
        emptyMessage="Momentáneamente no hay datos cargados para mostrar"
        striped
        hover
        bordered
      />


      {isActive("modalContacts") && (
        <AddContacts
          toggleModal
          urlTittle={"modalContacts"}
          onClose={() => {
            onClose("modalContacts");
            getContactsCall();
          }}
        />
      )}

      {isActive("modalUpdateContact") && (
        <UpdateContact
          urlTittle={"modalUpdateContact"}
          toggleModal
          onClose={() => {
            onClose("modalUpdateContact");
            getContactsCall();
          }}
        />
      )}

    </>
  );
};
export default Contactos;
